module.exports = __webpack_public_path__ + "static/media/delete-18.a45bcf74.svg";